'use client';
import { useState } from 'react';
import Link from 'next/link';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);

  const resourceLinks = [
    { href: '/ressources/specialites', label: 'Nos Spécialités', icon: 'fas fa-stethoscope' },
    { href: '/ressources/laboratoire', label: 'Laboratoire Montagnier', icon: 'fas fa-flask' },
    { href: '/ressources/endoscopie', label: 'Endoscopie', icon: 'fas fa-procedures' },
    { href: '/ressources/imagerie', label: 'Imagerie Médicale', icon: 'fas fa-x-ray' },
    { href: '/ressources/cosa-inside', label: 'COSA Inside', icon: 'fas fa-microscope' },
    { href: '/ressources/rse', label: 'RSE', icon: 'fas fa-hands-helping' },
  ];

  return (
    <header>
      {/* TOP BAR */}
      <div style={{ backgroundColor: '#0e5932' }} className="py-2">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
          <div className="flex items-center gap-6 text-white text-sm">
            <span className="flex items-center gap-2">
              <i className="fas fa-map-marker-alt" style={{ color: '#fbaf45' }}></i>
              <span className="hidden sm:inline">Yopougon, Ananeraie, Abidjan, Côte d'Ivoire</span>
            </span>
            <a href="tel:+2250000000000" className="flex items-center gap-2 text-white hover:text-yellow-300 transition-colors">
              <i className="fas fa-phone" style={{ color: '#fbaf45' }}></i>
              <span>+225 00 00 00 00</span>
            </a>
          </div>
          <div className="flex items-center gap-3">
            <a href="#" className="text-white hover:text-yellow-300 transition-colors text-sm"><i className="fab fa-facebook-f"></i></a>
            <a href="#" className="text-white hover:text-yellow-300 transition-colors text-sm"><i className="fab fa-twitter"></i></a>
            <a href="#" className="text-white hover:text-yellow-300 transition-colors text-sm"><i className="fab fa-linkedin-in"></i></a>
            <a href="#" className="text-white hover:text-yellow-300 transition-colors text-sm"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
      </div>
      {/* MAIN NAV */}
      <div className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* LOGO */}
            <Link href="/" className="flex items-center gap-2">
              <img
                src="/assets/images/logo-cosa.png"
                alt="COSA – Compagnie de Santé Africaine"
                style={{ height: 52, width: 'auto', maxWidth: 200, objectFit: 'contain', display: 'block' }}
              />
            </Link>

            {/* DESKTOP NAV */}
            <nav className="hidden lg:flex items-center gap-1">
              <Link href="/" className="px-4 py-2 text-gray-700 hover:text-green-800 font-semibold text-sm transition-colors">Accueil</Link>
              <Link href="/a-propos" className="px-4 py-2 text-gray-700 hover:text-green-800 font-semibold text-sm transition-colors">À Propos</Link>

              {/* RESOURCES DROPDOWN */}
              <div
                className="relative"
                onMouseEnter={() => setResourcesOpen(true)}
                onMouseLeave={() => setResourcesOpen(false)}
              >
                <button className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-green-800 font-semibold text-sm transition-colors">
                  Nos Ressources <i className="fas fa-chevron-down text-xs ml-1"></i>
                </button>
                {resourcesOpen && (
                  <div className="absolute top-full left-0 bg-white shadow-xl rounded-xl py-3 min-w-56 z-50" style={{ border: '1px solid #f0f0f0' }}>
                    {resourceLinks?.map((r, i) => (
                      <Link
                        key={i}
                        href={r?.href}
                        className="flex items-center gap-3 px-5 py-3 text-sm text-gray-700 hover:text-green-800 hover:bg-green-50 transition-colors"
                      >
                        <i className={`${r?.icon} text-xs w-4`} style={{ color: '#0e5932' }}></i>
                        {r?.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link href="/#footer-1" className="px-4 py-2 text-gray-700 hover:text-green-800 font-semibold text-sm transition-colors">Contact</Link>
              <Link
                href="/rendez-vous"
                className="ml-4 px-5 py-2 rounded text-white font-bold text-sm transition-all"
                style={{ backgroundColor: '#0e5932' }}
                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#0a3f24')}
                onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#0e5932')}
              >
                Prendre RDV
              </Link>
            </nav>

            {/* MOBILE TOGGLE */}
            <button
              className="lg:hidden p-2 text-gray-700"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              <i className={`fas ${mobileOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
            </button>
          </div>

          {/* MOBILE MENU */}
          {mobileOpen && (
            <div className="lg:hidden border-t border-gray-100 py-4">
              <nav className="flex flex-col gap-1">
                <Link href="/" className="px-4 py-2 text-gray-700 hover:text-green-800 font-semibold text-sm">Accueil</Link>
                <Link href="/a-propos" className="px-4 py-2 text-gray-700 hover:text-green-800 font-semibold text-sm">À Propos</Link>
                <div className="px-4 py-2">
                  <div className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: '#0e5932' }}>Nos Ressources</div>
                  {resourceLinks?.map((r, i) => (
                    <Link key={i} href={r?.href} className="flex items-center gap-2 py-1.5 text-sm text-gray-600 hover:text-green-800">
                      <i className={`${r?.icon} text-xs w-4`} style={{ color: '#0e5932' }}></i>
                      {r?.label}
                    </Link>
                  ))}
                </div>
                <Link href="/#footer-1" className="px-4 py-2 text-gray-700 hover:text-green-800 font-semibold text-sm">Contact</Link>
                <Link
                  href="/rendez-vous"
                  className="mx-4 mt-2 px-5 py-2 rounded text-white font-bold text-sm text-center block"
                  style={{ backgroundColor: '#0e5932' }}
                >
                  Prendre RDV
                </Link>
              </nav>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
